import { useMutation } from '@apollo/client';
import { SUBSCRIBE_FOR_BLOG_ALERTS } from 'apolloClient/mutations/alerts';
import React, { useEffect, useState } from 'react';
import {
  validateEmail,
  getLeadIdFromLocalStorage,
  saveLeadIdToLocalStorage,
  getbrowserUUIDFromLocalStorage,
} from 'src/utils/utils';

const SignUpSection: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  const [subscribeForBlogAlerts] = useMutation(SUBSCRIBE_FOR_BLOG_ALERTS);
  const onSubmit = async () => {
    if (email && validateEmail(email)) {
      const leadId = getLeadIdFromLocalStorage() || null;
      const browserUUID = getbrowserUUIDFromLocalStorage() || null;

      const data = await subscribeForBlogAlerts({
        variables: {
          email,
          leadId,
          browserUUID,
        },
      });

      try {
        const newLeadId = data?.data?.subscribeUserForBlog?.newLeadId;

        if ((!leadId && newLeadId) || leadId !== newLeadId) {
          saveLeadIdToLocalStorage(newLeadId);
        }
      } catch (error) {
        console.error(error);
      }

      setIsSubmitted(true);
    }
  };

  useEffect(() => {
    if (isSubmitted) {
      const timeoutId = setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
      setEmail('');

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isSubmitted]);

  return (
    <section className="bg-white-dark">
      <div className="container flex w-full h-[297px] lg:h-[330px] text-14-26-0.3 bg-center bg-no-repeat bg-cover lg:justify-center pl-[20px] lg:pl-[53px] lg:pt-[7px] lg:pb-2 ">
        <div className="flex flex-col md:pl-[143px] lg:pl-0 pt-[60px] md:pt-[56px] lg:pt-16 lg:pb-20">
          <h2 className="text-23-29-0.3 lg:text-30-47-1 tracking-[0.77px] uppercase font-sohneBreitHalbfett">
            Sign up now
          </h2>
          {isSubmitted ? (
            <p className="text-14-21-0.3 md:text-16-26-0.3 mt-[16px] mb-[37px] lg:my-10">
              You have successfully signed for news and updates.
            </p>
          ) : (
            <>
              <p className="text-14-21-0.3 md:text-16-26-0.3 mt-[16px] md:mt-[32px] mb-[37px] lg:mt-[25px] md:mb-[29px] lg:my-10">
                Get news and updates delivered to your inbox
              </p>
              <div className="flex">
                <input
                  className="w-[245px] md:w-[361px] lg:w-[431px] h-[44px] text-16-21-0.3 border form-input"
                  type="email"
                  placeholder="Your email"
                  onChange={(event) => setEmail(event.target.value)}
                />
                <button
                  className="w-[89px] md:w-[139px] h-full text-14-21-0.3 uppercase md:text-14-21-0.3 lg:text-16-21-0.3 bg-gold border-gold"
                  onClick={onSubmit}
                >
                  Sign up
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default SignUpSection;
